var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6045 10.6041L7.62051 13.5881C7.49002 13.7187 7.33506 13.8223 7.16449 13.893C6.99392 13.9637 6.81109 14.0001 6.62645 14.0001C6.44181 14.0001 6.25898 13.9637 6.08841 13.893C5.91785 13.8223 5.76289 13.7187 5.63239 13.5881L2.64775 10.6041C1.86095 9.81729 1.32515 8.81481 1.10809 7.72347C0.891024 6.63212 1.00246 5.50091 1.42829 4.47289C1.85413 3.44488 2.57524 2.56622 3.50044 1.94803C4.42564 1.32984 5.51338 0.999878 6.6261 0.999878C7.73883 0.999878 8.82656 1.32984 9.75176 1.94803C10.677 2.56622 11.3981 3.44488 11.8239 4.47289C12.2497 5.50091 12.3612 6.63212 12.1441 7.72347C11.9271 8.81481 11.3912 9.81729 10.6045 10.6041Z",
    stroke: "#323352",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73587 6.62578C8.73587 7.18533 8.51359 7.72196 8.11793 8.11762C7.72227 8.51328 7.18563 8.73556 6.62608 8.73556C6.06653 8.73556 5.5299 8.51328 5.13424 8.11762C4.73858 7.72196 4.5163 7.18533 4.5163 6.62578C4.5163 6.06623 4.73858 5.52959 5.13424 5.13393C5.5299 4.73827 6.06653 4.51599 6.62608 4.51599C7.18563 4.51599 7.72227 4.73827 8.11793 5.13393C8.51359 5.52959 8.73587 6.06623 8.73587 6.62578Z",
    stroke: "#323352",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.784079ad06906f265af971ae97bfcb87.svg";
export { ForwardRef as ReactComponent };